





















































import Vue from "vue";
import Axios from "axios";
import CreateSequenceForm from "@/components/sequence/CreateSequenceForm.vue";
import { firestore } from 'firebase';

export default Vue.extend({
  components: { CreateSequenceForm },
  props: {
    viewId: {
      type: String,
    },
  },

  data() {
    return {
      videos: [] as any[],
      latestImageURL: '',
      sequences: [] as any[],
      showSequenceCreationModal: false,
      unsubscribe: () => null as any,
      dates: {
        type: Array as () => Array<string>,
        default: () => {
        return [] as string[];
        },
      },
    };
  },

  methods: {
    GetStatusType(status)
    {
        if(status === 'upload failed') return "error";
        if(status === 'preparation failed') return "error";
        if(status === 'failed') return "error";
        if(status === 'no images') return "error";
        if(status === 'too many images') return "error";
        if(status === 'video creation failed') return "error";
        if(status === 'complete') return "success";

        return "info"
    },
    getVideos() {
      const videos = [] as any[];
      let videosRef = this.$db.collection("videos");
      let query;

      const claims = this.$store.state.auth.token.claims;

      if (claims.super) {
        query = videosRef.where("views", "array-contains", this.viewId);
      } else if (claims.partner) {
        query = videosRef.where("partners", "array-contains", claims.partner);
      } else if (claims.client) {
        query = videosRef.where("clients", "array-contains", claims.client);
      } else {
        query = videosRef.where(
          "users",
          "array-contains",
          this.$store.state.auth.user.uid
        );
      }
      query
        .orderBy("order", "desc")
        .get()
        .then((snapshot) => {
          if (snapshot.size) {
            snapshot.forEach((doc) => {
              let video = {_id: doc.id, ...doc.data()}
              let videoThumnail = this.latestImageURL;
              if(video.thumbnail) videoThumnail = video.thumbnail;
              video.thumbnail = videoThumnail;
              videos.push( video );
            });
          }
          this.videos = videos.filter(
            (video) => video.views.indexOf(this.viewId) > -1
          ).sort((a, b) => this.compareVideos(a, b));
          
            window.console.log(JSON.stringify(this.videos ));
        })
        .catch((err) => {
          window.console.log(err);
        });
    },    
    compareVideos(a, b)
    {
            window.console.log("Comparing Videos.");
      // equal items sort equally
      if (a === b) {
            window.console.log("equal.");
        return 0;
      }      
      if (a.createdTimeUtc == null && b.createdTimeUtc == null) {
            window.console.log("times both null.");
        return 1;
      }
      else if(a.createdTimeUtc == null && b.createdTimeUtc != null)
      {
            window.console.log("a null b not null.");
        return 1;
      }
      else if(b.createdTimeUtc == null && a.createdTimeUtc != null)
      {
            window.console.log("b null a not null.");
        return -1;
      }
      // nulls after anything else
      // else if(a.order === 0)
      // {
      //   return 1;
      // }
      // else if(b.order === 0)
      // {
      //   return -1;
      // }

      else if(a.createdTimeUtc === null)
      {
            window.console.log("a null ");
        return 1;
      }
      else if(b.createdTimeUtc === null)
      {
            window.console.log("b null ");
        return -1;
      }
      window.console.log("comparing ");
      return a.createdTimeUtc < b.createdTimeUtc ? 1 : -1;
      //this.videos.sort((a, b) =>  ((a.createdTimeUtc > b.createdTimeUtc) ? 1 : -1));
     // this.videos.sort((a, b) => (a.order > b.order) ? 1 : (a.order === b.order) ? ((a.createdTimeUtc > b.createdTimeUtc) ? 1 : -1) : -1 );
    },
    getSequences() {
      window.console.log("Getting Sequences");
      let sequencesRef = this.$db.collection("sequences")
      let query;

      const claims = this.$store.state.auth.token.claims;

      if (claims.super) {
        query = sequencesRef.where("views", "array-contains", this.viewId);
      } else if (claims.partner) {
        query = sequencesRef.where("partners", "array-contains", claims.partner);
      } else if (claims.client) {
        query = sequencesRef.where("clients", "array-contains", claims.client);
      } else {
        query = sequencesRef.where(
          "users",
          "array-contains",
          this.$store.state.auth.user.uid
        );
      }

      this.unsubscribe = query.onSnapshot((snapshot:firestore.QuerySnapshot) => {
        if(snapshot.docChanges().length) {
          snapshot.docChanges().forEach(change => {
            const item:{[key:string]:any} = {_id: change.doc.id, ...change.doc.data()}
            const index = this.sequences.findIndex(_item => {
              return _item._id == item._id
            });
      
            var createdSequence = this.$store.state.sequence;
            if(createdSequence.uiId === null || createdSequence.uiId === "") 
            {
              return;
            }
            if(item.uiId === null || item.uiId === "") 
            {
              return;
            }
            if(createdSequence.uiId !== item.uiId) 
            {
              return;
            }
            var statusType = this.GetStatusType(item.status);
            window.console.log("Current Id: " + createdSequence.uiId + " New id: " + item.uiId);
            var displayStatus = item.status.charAt(0).toUpperCase() + item.status.slice(1);
            if(index === -1) 
            {
              window.console.log("Add item to list: " + item.name + " Index:" + index);
              this.$set(this.sequences, this.sequences.length, item);
              (this as any).flashMessage.show({status: statusType, title: item.name, message: displayStatus, time: 0 })       
              return;
            }
            if(this.sequences[index].status != item.status)
            {
              //window.console.log(JSON.stringify(item));
              window.console.log("Status changed: current: " + this.sequences[index].status + " New: " + item.status + " Index:" + index);
              this.$set(this.sequences, index, item);
              (this as any).flashMessage.show({status: statusType, title:item.name, message: displayStatus, time: 0 })       
            }
            
            if(statusType === "success")
            {
              this.getVideos();
              this.sequences = [];
            }
          })
        }
      })
    },
    
    loadCreateSequence() {
      this.showSequenceCreationModal = true;
    },
    hideCreateSequenceModal() {
      this.showSequenceCreationModal = false;
    },
    async deleteVideo(id) {
      if(confirm("This action cannot be undone. Are you sure?")){
        try {
            const index = this.videos.findIndex(_item => {
              return _item._id == id
            });
            
          const result = await this.$api.remove("videos", id)
          if(index > -1)
          {
            this.videos.splice(index, 1);
          }
          window.console.log(result);
          (this as any).flashMessage.show({status: "success", title: "Success", message: "Successfully deleted video.", time: 4000 })    
        } catch (err) {
         window.console.error(err);
         alert("An unexpected error occurred.");
        }
      }
    },    
    getViewData() {
      this.$db.collection('views').doc(this.viewId).get().then(doc => {
        let view = {} as any
        if (doc.exists) {
          view = {_id: doc.id, ...doc.data()}

          const enabledDates = view.enabledDates.sort((a,b) => a > b ? 1 : -1)
          this.dates = enabledDates
          this.latestImageURL = view = view.latestImageURL;
        }
      })
    }
  },

  created() {
    this.getViewData();
    this.getVideos();
    this.getSequences();
    this.$store.commit("sequence/setUiId", "");
  },
  beforeDestroy() {
    this.$store.commit("sequence/setUiId", "");
    this.unsubscribe()
  }
});
